// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { EmailMessage } from './email-message';
import { Invoice } from './invoice';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class EmailMessageInvoiceLink extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  emailMessageId!: number;
  invoiceId!: number;
  emailMessage!: EmailMessage;
  invoice!: Invoice;
}

